export const fieldTypes = [
  {
    id: 0,
    fieldName: 'Texto Simples',
    internalTypeName: 'inputText',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Texto de Marcação',
      charMask: 'Marcara de Caracteres'
    }
  },
  {
    id: 1,
    fieldName: 'Texto Longo',
    internalTypeName: 'inputArea',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Texto de Marcação',
      maxLength: 100
    }
  },
  {
    id: 2,
    fieldName: 'Numérico',
    internalTypeName: 'inputNumber',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Texto de Marcação',
      minValue: 5,
      maxValue: 10
    }
  },
  {
    id: 3,
    fieldName: 'Data',
    internalTypeName: 'date',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Texto de Marcação',
      format: 'DD/MM/AAAA',
      range: [0, 1]
    }
  },
  {
    id: 4,
    fieldName: 'Localização',
    internalTypeName: 'location',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Compartilhe sua Localização'
    }
  },
  {
    id: 5,
    fieldName: 'Lista de Seleção',
    internalTypeName: 'select',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,
    fieldProperties: {
      placeholder: 'Selecione',
      options: []
    }
  },
  {
    id: 6,
    fieldName: 'Arquivos',
    internalTypeName: 'upload',
    fieldGroup: null,
    fieldTypeId: null,
    fieldRow: 1,
    fieldColumn: 1,
    requiredField: true,
    parentFieldId: null,
    parentFieldAnswer: null,
    active: true,
    unsaved: false,

    fieldProperties: {
      placeholder: 'Compartilhe um arquivo',
      fileType: [],
      fileSize: 100,
      sizeType: 'MB',
      maxFilesLength: 1
    }
  },
  {
    id: 7,
    fieldName: 'Grupo',
    internalTypeName: 'group',
    fieldProperties: {},
    fieldGroup: null,
    active: true,
    isGroup: true,
    children: [],
    unsaved: false
  }
]
